// extracted by mini-css-extract-plugin
export default {"customField":"CustomExtendedDataField_customField__qwZyL","fieldWithHelp":"CustomExtendedDataField_fieldWithHelp__r5Zok","helpText":"CustomExtendedDataField_helpText__D4IUb"};